/* Phase 13D -- Reception Today live-counts tile for CEO/ADMIN/FDE home. */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Users, Truck, IdCard, DoorOpen } from "lucide-react";
import api from "@/lib/api";

function Bucket({ icon: Icon, label, value, color, to, testid }) {
  return (
    <Link to={to} className="flex-1 min-w-[120px] rounded p-2.5 border border-white/10 bg-white/3 hover:bg-white/5 transition-colors"
          data-testid={testid}>
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 rounded flex items-center justify-center" style={{ background: color + "20" }}>
          <Icon className="h-4 w-4" style={{ color }}/>
        </div>
        <div>
          <div className="text-xl font-bold tabular-nums leading-none">{value ?? "-"}</div>
          <div className="text-[10px] uppercase tracking-widest text-foreground/60 mt-0.5">{label}</div>
        </div>
      </div>
    </Link>
  );
}

export default function ReceptionTodayCard() {
  const [d, setD] = useState(null);
  const load = async () => {
    try {
      const { data } = await api.get("/visitors/reception-summary");
      setD(data);
    } catch (_e) { /* silently hide for non-permitted roles */ }
  };
  useEffect(() => {
    load();
    const iv = setInterval(load, 60000);
    const onFocus = () => load();
    window.addEventListener("focus", onFocus);
    return () => { clearInterval(iv); window.removeEventListener("focus", onFocus); };
  }, []);
  if (!d) return null;
  return (
    <div className="glass-elevated p-3 mt-4" data-testid="reception-today-card">
      <div className="text-[10px] uppercase tracking-widest text-foreground/50 mb-2">
        Reception . live now
      </div>
      <div className="flex gap-2 flex-wrap">
        <Bucket icon={Users} label="Visitors in office" value={d.visitors_in_office}
                color="#1E96FC" to="/front-desk/visitors" testid="rec-tile-visitors"/>
        <Bucket icon={Truck} label="Couriers pending handover" value={d.couriers_awaiting_handover}
                color="#F59E0B" to="/front-desk/couriers" testid="rec-tile-couriers"/>
        <Bucket icon={IdCard} label="ID cards to collect" value={d.idcards_printed_uncollected}
                color="#10B981" to="/front-desk/id-cards" testid="rec-tile-idcards"/>
        <Bucket icon={DoorOpen} label="Rooms occupied now" value={d.rooms_occupied_now}
                color="#8B5CF6" to="/front-desk/meeting-rooms" testid="rec-tile-rooms"/>
      </div>
    </div>
  );
}
